export enum IETM_TOC_VIEW_MODE {
    SNS = 'sns',
    MANUAL = 'manual',
    MODULE = 'module',
    FILTERS = 'filters'
}
